export default __webpack_public_path__ + "static/media/appGallery-es.6725d42d.svg";